
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import langSwitch from "../layout/components/lang-switch.vue";
import { usernameRuleEl, mobileRules } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const common_app = namespace("common_app");
@Component({
  components: { langSwitch }
})
export default class Login extends Vue {
  @user.Action login;
  @user.Action queryUserMenus;
  @user.Action getUserData;
  @user.Action setCurrentStore;
  @user.State userData;
  @user.Action queryUserResources;
  @app.Getter isAgreementProtocol;
  @app.Mutation setAgreementProtocolFlag;
  @app.State protocolVersion;
  @app.Mutation setProtocolVersion;
  @base.Action getProtocolVersion;
  @app.State country;
  @user.Mutation setPermissionList;
  @user.State menuList;
  @user.Action getMobileCode;
  @common_app.State lang;
  loginForm: any = {
    account: "",
    password: "",
    verificationCode: "",
    loginOperateType: "1",
    verificationCodeToken: "",
    mobile: ""
  };
  loginLoading: boolean = false;
  leftTitle: boolean = true;
  get isDemo() {
    return this.$route.query.demo === "1";
  }
  get rules() {
    return {
      account: [
        {
          required: true,
          message: t("login.username-empty-tips"),
          trigger: "blur"
        },
        { validator: this.validatUsername, trigger: "blur" }
      ],
      password: [
        {
          required: true,
          message: t("login.password-empty-tips"),
          trigger: "blur"
        }
      ],
      verificationCode: [
        {
          required: true,
          message: t("login.verifiCode-empty-tips"),
          trigger: "blur"
        },
        { validator: this.validatCode, trigger: "blur" }
      ],
      mobile: [
        {
          required: true,
          message: t("v210930.Please-enter-your-mobile-phone-number"),
          trigger: "blur"
        },
        { validator: this.validatMobole, trigger: "blur" }
      ]
    };
  }
  isServerError: boolean = false;
  serverErrorMsg: string = "";
  isShowStoreList: boolean = false;
  created() {
    this.checkProtocolVersion();
    if (this.isDemo) {
      this.loginForm.account = "18812345678";
      this.loginForm.password = "18812345678";
    }
  }
  protocolVersionTemp: string = "";
  checkProtocolVersion() {
    this.getProtocolVersion().then(({ data: { version } }) => {
      this.protocolVersionTemp = version;
      if (version === this.protocolVersion) {
        this.setAgreementProtocolFlag(1);
      } else {
        this.setAgreementProtocolFlag(0);
      }
    });
  }
  handleCheckProtocol(val) {
    if (val) {
      this.setAgreementProtocolFlag(1);
      this.setProtocolVersion(this.protocolVersionTemp);
    } else {
      this.setProtocolVersion("");
      this.setAgreementProtocolFlag(0);
    }
  }
  submitForm(refName) {
    (this.$refs[refName] as any).validate((valid, error) => {
      console.log("[ error ]", error);
      if (valid) {
        if (!this.isAgreementProtocol) {
          this.serverErrorMsg = t("v210906.please-read-the-relevant-agreement-and-check-agree");
          this.isServerError = true;
          return;
        }
        this.loginLoading = true;
        this.login(this.loginForm).then(
          async () => {
            try {
              await this.getUserData();
              if (this.userData.storeList.length > 1) {
                this.isShowStoreList = true;
                await this.handleSelectStore(this.userData.storeList[0].orgCode, false); // 登录后默认选取第一家店
              } else if (this.userData.storeList.length === 1) {
                await this.handleSelectStore(this.userData.storeList[0].orgCode);
              } else {
                this.$message.error(t("user.current-user-has-no-door-shop"));
              }
            } catch (e) {
              this.loginLoading = false;
            }
            this.loginLoading = false;
          },
          data => {
            this.serverErrorMsg = data.message;
            this.isServerError = true;
            this.loginLoading = false;
          }
        );
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  getFirstRoutePath() {
    let path = "";
    function f(arr) {
      if (path) return path;
      if (arr[0].pageUrl) {
        path = arr[0].pageUrl;
      } else {
        let oneArr = arr[0].children;
        for (let i = 0; i < oneArr.length; i++) {
          if (oneArr[0].pageUrl) {
            path = oneArr[0].pageUrl;
            return path;
          } else {
            f(oneArr[0].children);
          }
        }
      }
    }
    f(this.menuList);
    return path;
  }
  validatUsername(rule, value, callback) {
    usernameRuleEl(value, callback);
  }
  validatMobole(rule, value, callback) {
    if (mobileRules(value).success === true) {
      callback();
    } else {
      callback(new Error(mobileRules(value).msg));
    }
  }
  validatCode(rule, value, callback) {
    this.checkCode(value, callback);
  }
  checkCode(value, callback) {
    if (!this.loginForm.verificationCodeToken) {
      callback(new Error(t("v213.Obtain-the-verification-code")));
    } else {
      callback();
    }
  }
  backLogin() {
    this.isShowStoreList = false;
    this.loginForm.account = "";
    this.loginForm.password = "";
    this.isServerError = false;
    this.serverErrorMsg = "";
  }
  async handleSelectStore(id, toIndex = true) {
    return this.setCurrentStore({
      orgCode: id
    }).then(
      async () => {
        const menus = await this.queryUserMenus({
          menuParent: "pc_root",
          resourceClass: "1"
        });
        if (menus.data.list.length < 1) {
          this.$message.error(t("user.current-user-has-no-permissions"));
          return;
        }
        await this.queryUserResources().then(data => {
          let permitList = (data.data.list || [])
            .filter(item => {
              return item.resourceType === "4";
            })
            .map(item => item.resourceCode);
          this.setPermissionList(permitList);
        });
        toIndex && this.$router.push(this.getFirstRoutePath());
      },
      res => {
        if (res.code === "speedbiz.app-version-expire-error") {
          this.isShowStoreList = false;
        }
      }
    );
  }
  handleLinkLegalAgreement() {
    let { href } = this.$router.resolve({
      path: `/legal-notice`
    });
    window.open(href, "_blank");
  }
  handleLinkUserAgreement() {
    let { href } = this.$router.resolve({
      path: `/user-agreement`
    });
    window.open(href, "_blank");
  }
  handleLinkPrivacy() {
    let { href } = this.$router.resolve({
      path: `/privacy-policy`
    });
    window.open(href, "_blank");
  }
  clickLoginType(type) {
    (this.$refs as any).loginForm.resetFields();
    this.loginForm.loginOperateType = type;
    if (type === "1") {
      this.leftTitle = true;
    } else if (type === "3") {
      this.leftTitle = false;
    }
  }
  getMesageFlag = true;
  hasSendCode: boolean = false;
  changeLoading: boolean = false;
  timer: any;
  countDownNum: number = 60;
  checkMobile(refName) {
    (this.$refs[refName] as any).validateField("mobile", errorMessage => {
      if (!errorMessage && this.getMesageFlag) {
        this.getMesageFlag = false;
        this.getVerificationCode();
      }
    });
  }
  async getVerificationCode() {
    if (this.hasSendCode) {
      return;
    }
    // 获取mobileCode接口
    this.getMobileCode({
      mobile: this.loginForm.mobile,
      validationCodeType: "3" // 获取短信类型
    })
      .then(data => {
        this.loginForm.verificationCodeToken = data.data.validationToken;
        this.hasSendCode = true;
        this.timer = setInterval(() => {
          if (--this.countDownNum === 0) {
            clearInterval(this.timer);
            this.hasSendCode = false;
            this.countDownNum = 60;
            this.getMesageFlag = true;
          }
        }, 1000);
        this.$message.success(
          t("v210906.tail-number") + data.data.mobileSuffix + t("v210906.verification-code-sent-to-mobile-phone")
        );
      })
      .catch(data => {
        console.log("[ catchdata ]", data);
        this.isServerError = true;
        this.changeLoading = false;
        this.getMesageFlag = true;
        this.serverErrorMsg = data.message;
      });
  }
}
